export default {"src":"/_next/static/media/stack-plus.7c0ffd01.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};